var indentation_default = {
  "indentZero": "-vCWA",
  "indentOne": "OymIU",
  "indentTwo": "Dqzls",
  "indentThree": "_9yKn9",
  "indentFour": "SZo-u",
  "indentFive": "a3qJv",
  "indentSix": "xRxBD"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
